module.exports = __webpack_public_path__ + "img/logo.8674ebaf.png";